import { Component, Output, OnInit, OnDestroy } from '@angular/core';
import { FormGroupDirective, ControlContainer, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UsedSgkc006aService } from '../../services/used-sgkc006a.service';
import { UsedSgkc007aService } from '../../services/used-sgkc007a.service';
import { CodeConversionMstDto, Sgkc006aReqTankatableSearchinfoDto, Sgkc006aRequest, Sgkc007aReqTankatableShutokuinfoDto, Sgkc007aRequest, Sgkc026aReqTankaApprvalauthShutokuinfoDto, Sgkc026aRequest, Sgkc026aResponse, TankatableLstInformationDto } from 'sg-api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SearchStat } from '../../../../../sg-kc-shared/constants/searchStat';
import { DisplayMode } from 'cbc-shared-lib';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { UsedSgkc026aService } from '../../services/used-sgkc026a.service';
import { TankaauthorityDivcd } from '../../../../../sg-kc-shared/constants/tankaauthorityDivcd';

/** 
 * 単価表検索画面
 * @exports
 * @class Sgkc021dComponent
 * @implements {OnInit,OnDestroy}
 */
@Component({
    selector: 'app-sgkc021d',
    templateUrl: './sgkc021d.component.html',
    styleUrl: './sgkc021d.component.scss',
    providers: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})

export class Sgkc021dComponent implements OnInit, OnDestroy {

    /** 各必須項目の初期値 */
    readonly DEFAULT_SELECT_VALUE = " ";

    /** エラーメッセージリスト */
    @Output() errorMessageModelArray: Array<SgAriaMessage>;
    /** コード変換マスタMap */
    @Output() codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;
    /** 単価表検索フォーム */
    tankatableConditionForm: UntypedFormGroup;
    /** 単価表検索結果 */
    searchResult: TankatableLstInformationDto[];
    /** 単価表承認権限取得結果 */
    sgkc026aResponse: Sgkc026aResponse;
    /*コード変換マスタ結果 */
    codeConversionMstDto: Map<string, CodeConversionMstDto[]>;
    /** 購読を停止するためのSubject */
    private onDestroy$ = new Subject();
    /** 選択情報 */
    selectedSearchResultRowInfo: TankatableLstInformationDto;
    /** 表示フラグ */
    showResult: boolean = false;
    /** 画面モードコード */
    displayMode: string;
    /** 承認ステータスコード */
    apprvStatuscode: string;
    /** 単価権限区分コード */
    tankaauthorityDivcd: string;

    /** 
    * コンストラクタ
    * @param {Router} router 
    * @param {UntypedFormBuilder} fb 
    * @param {UsedSgkc006aService} usedSgkc006aService 
    * @param {UsedSgkc007aService} usedSgkc007aService 
    * @param {CodeConversionMstService} codeConversionMstService 
    * @param {UsedSgkc026aService} usedSgkc026aService 
    * @param {ActivatedRoute} route
    * @memberof Sgkc021dComponent
   */
    constructor(private router: Router,
        private fb: UntypedFormBuilder,
        private usedSgkc006aService: UsedSgkc006aService,
        private usedSgkc007aService: UsedSgkc007aService,
        private codeConversionMstService: CodeConversionMstService,
        private usedSgkc026aService: UsedSgkc026aService,
        private route: ActivatedRoute,) {
        this.tankatableConditionForm = this.fb.group({});
    }

    /** 
     * 初期処理
     * @memberof Sgkc021dComponent
     */
    ngOnInit(): void {

        // 画面モードを取得
        this.route.paramMap.subscribe(params => {

            this.showResult = false;
            this.displayMode = params.get('mode');

            if (this.displayMode === DisplayMode.create) {
                this.tankaauthorityDivcd = TankaauthorityDivcd.create;
            } else if (this.displayMode === DisplayMode.read) {
                this.tankaauthorityDivcd = TankaauthorityDivcd.read;
            } else if (this.displayMode === DisplayMode.approve) {
                this.tankaauthorityDivcd = TankaauthorityDivcd.approve;
            } else if (this.displayMode === DisplayMode.delete) {
                this.tankaauthorityDivcd = TankaauthorityDivcd.create;
            }
            // 受信データの購読設定。
            // 検索結果に値が流れたときに、検索結果を表示するプレゼンテーショナルコンポーネントに渡している値を更新する。
            this.usedSgkc006aService.tankatableChanges
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(tanka => {
                    this.searchResult = tanka;
                });
            this.usedSgkc007aService.tankatableDetailChanges
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(response => {
                    // 単価表登録管理情報.承認ステータスコードを取得
                    this.apprvStatuscode = response.tankatableregistrationManageInfo.apprvStatuscode;
                    // 承認ステータスコードが承認済のとき
                    if (this.apprvStatuscode === SearchStat.SHONINZUMI) {
                        // 次の画面へ遷移
                        this.router.navigate(['/sgkc/sgkc012d', {
                            mode: this.displayMode,// 画面モードコード
                            tankatableCode: this.selectedSearchResultRowInfo.tankatableCode,// 単価表コード
                            backmode: this.displayMode,// 画面モードコード
                        }])
                    } else if (this.apprvStatuscode === SearchStat.mishonin) {// 未承認のとき
                        window.alert("未承認の単価表が存在します。");
                    }
                });
            this.usedSgkc026aService.tankatableAuthorityChanges
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(response => {
                    this.sgkc026aResponse = response;
                });

            // 単価表承認権限取得API
            // 画面引継ぎ項目単価権限区分コードを取得しリクエストを作成
            const tankaApprvalauthShutokuinfo: Sgkc026aReqTankaApprvalauthShutokuinfoDto = {
                tankaauthorityDivcd: this.tankaauthorityDivcd // 単価権限区分コード
            }
            const sgkc026aRequest: Sgkc026aRequest = {
                tankaApprvalauthShutokuinfo: tankaApprvalauthShutokuinfo
            }
            // 単価表承認権限取得APIを呼び出し
            this.usedSgkc026aService.getTankatableAuthorityInf(sgkc026aRequest)
                .subscribe(response => {
                }, error => {
                });

            this.codeConversionMstService.getCodeConversionMst([
                "S900020",// 会社コード
                "S100020",// エネルギー種別
                "S100110",// ＬＰ販売形態
                "S100031",// 承認ステータス
            ])
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(data => {
                    this.codeConversionMstMap = data;
                });
        });
    }

    /** 
    * 購読を停止する処理
    * @memberof Sgkc021dComponent
    */
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    /** 
     * クリアボタン押下処理
     * @memberof Sgkc021dComponent
     */
    onClickClear() {
        this.tankatableConditionForm.reset();
        this.showResult = false;
    }

    /** 
     * 検索ボタン押下処理
     * @memberof Sgkc021dComponent
     */
    onClickSearch(): void {
        this.showResult = false;
        // リクエストを作成
        let form = this.tankatableConditionForm.getRawValue().tankatableConditionInfo;
        const tankatableSearchinfo: Sgkc006aReqTankatableSearchinfoDto = {
            companygroupcode: null,// 会社グループコード
            companycode: form.companycode,// 会社コード
            energyClscode: form.energyClscode,// エネルギー種別コード
            apprvAuthorityCode: form.apprvAuthorityCode,// 承認権限コード
            lpSalesformcode: form.lpSalesformcode === this.DEFAULT_SELECT_VALUE ? null : form.lpSalesformcode,// ＬＰ販売形態コード
            locationgroupSuppntDivisionnumber: form.locationgroupSuppntDivisionnumber === this.DEFAULT_SELECT_VALUE ? null : form.locationgroupSuppntDivisionnumber,// 地点群供給地点区分番号
            searchTargetYm: form.searchTargetYm === '' || form.searchTargetYm === null ? null : form.searchTargetYm.replace('-', ''), // 検索対象年月承認ステータスコード
            apprvStatuscode: form.apprvStatuscode,// 承認ステータスコード
            referencetableOutputTargetflag: null // 早見表出力対象フラグ
        };
        const request: Sgkc006aRequest = {
            tankatableSearchinfo: tankatableSearchinfo
        };
        // サービス呼び出し
        this.usedSgkc006aService.searchTankatable(request)
            .subscribe(response => {
                if (response) {
                    this.showResult = true;
                }
            }, error => {
            });
    }

    /** 
     * 行ダブルクリック時の処理
     * @param {TankatableLstInformationDto} row
     * @memberof Sgkc021dComponent
     */
    onDbClickRow(row: TankatableLstInformationDto): void {
        /** 単価表登録画面への遷移 */
        //画面モードが登録のとき参照モードに、それ以外はそのまま設定
        const paramdisplayMode = this.displayMode === DisplayMode.create ? DisplayMode.read : this.displayMode;
        this.router.navigate(['/sgkc/sgkc012d', {
            backmode: this.displayMode, // 戻るボタン用画面モード
            mode: paramdisplayMode,// 画面モード
            tankatableCode: row.tankatableCode,// 単価表コード
            tankatableregistrationManagementserialnumber: row.tankatableregistrationManagementserialnumber,// 単価表登録管理通番
        }])
    }

    /** 
     * 行選択時の処理
     * @param {TankatableLstInformationDto} event
     * @memberof Sgkc021dComponent
     */
    onSelected(event: TankatableLstInformationDto): void {
        this.selectedSearchResultRowInfo = event;
    }

    /** 
     * 追加ボタン押下処理
     * @memberof Sgkc021dComponent
     */
    onClickAdd(): void {
        // リクエストの作成
        const tankatableShutokuinfo: Sgkc007aReqTankatableShutokuinfoDto = {
            tankatableCode: this.selectedSearchResultRowInfo.tankatableCode,
            tankatableregistrationManagementserialnumber: null
        };
        const request: Sgkc007aRequest = {
            tankatableShutokuinfo: tankatableShutokuinfo
        };
        this.usedSgkc007aService.getTankatableDetail(request)
            .subscribe(response => {
            }, error => {
            });
    }
}
